<div class="flex flex-col view-update-results">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>

  <div class="flex flex-row justify-between mb-20">
    <div *ngIf="viewAllResults; else viewLatest" class="mat-body-2 fw-700">
      {{'CONFIGURATIONS.VIEW_RESULTS.ALL_RESULTS' | transloco:
        {results: (configurationStates.length === filteredConfigurationStates.length ? configurationStates.length :
          ('COMMON.NUMBER_OF_TOTAL' | transloco : {num: filteredConfigurationStates.length , total:filteredConfigurationStates.length }))} }}
    </div>
    <ng-template #viewLatest>
      <div class="mat-body-2 fw-700">{{'CONFIGURATIONS.VIEW_RESULTS.RESULTS' | transloco: {results: filteredConfigurationStates.length} }}</div>
    </ng-template>

    <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
  </div>
  <div *ngIf="pageConfigurationStates && pageConfigurationStates.length > 0 ; else noDataFound" class="tbl tbl-configuration-state w-100-percent height-view-release pr-12">
    <div class="tbl-header-row primary mb-8 user-select-none">
      <div class="tbl-cell col-expand"></div>
      <div class="tbl-cell col-release-package-name">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME' | transloco }}</div>
      <div class="tbl-cell col-version">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION' | transloco }}</div>
      <div class="tbl-cell col-start-time" [ngClass]="{ 'cursor-pointer' : viewAllResults }" (click)="doSort('applicationStartTime')">
        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}
        <ng-container [ngTemplateOutlet]="sortIcon"
          [ngTemplateOutletContext]="{sort: sort, property: 'applicationStartTime'}"></ng-container>
      </div>
      <div class="tbl-cell col-end-time" [ngClass]="{ 'cursor-pointer' : viewAllResults }" (click)="doSort('applicationFinishTime')">
        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}
        <ng-container [ngTemplateOutlet]="sortIcon"
          [ngTemplateOutletContext]="{sort: sort, property: 'applicationFinishTime'}"></ng-container>
      </div>
      <div class="tbl-cell col-duration" [ngClass]="{ 'cursor-pointer' : viewAllResults }" (click)="doSort('duration')">
        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}
        <ng-container [ngTemplateOutlet]="sortIcon"
          [ngTemplateOutletContext]="{sort: sort, property: 'duration'}"></ng-container>
      </div>
      <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
    </div>
    <div class="tbl-body">
      <div *ngFor="let configurationState of pageConfigurationStates" class="tbl-border mb-8">
        <div class="tbl-body-row tbl-high-row" [ngClass]="{'expanded': expandedRows[configurationState.id]}">
          <div class="justify-items-center tbl-cell col-expand user-select-none" (click)="expandRow(configurationState)">
            <mat-icon class="cursor-pointer" [svgIcon]="expandedRows[configurationState.id] ? 'expand_more' : 'chevron_right'"></mat-icon>
          </div>
          <div class="tbl-cell col-release-package-name">
            {{ configurationsMap[configurationState.configurationId].manifest.name }}
            <div *ngIf="configurationState?.codeResult" class="code-package ml-16" ><mat-icon svgIcon="integration_instructions" [matTooltip]="'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE_AVAILABLE' | transloco | titlecase" 
              matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16" class="icon-md-1"></mat-icon></div>
            <button *ngIf="configurationState?.hotfix === true" class="flex flex-row jutsify-center items-center hotfix mt-4 ml-16 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
          </div>
          <div class="tbl-cell col-version">
            {{ configurationsMap[configurationState.configurationId].manifest.version }}
          </div>
          <div class="tbl-cell col-start-time">
            {{ configurationState.applicationStartTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET }}
          </div>
          <div class="tbl-cell col-end-time">
            {{ configurationState?.applicationFinishTime? (configurationState?.applicationFinishTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
          </div>
          <div class="tbl-cell col-duration">
            {{ configurationState.applicationStartTime | duration : configurationState.applicationFinishTime : '-' }}
          </div>
          <div class="tbl-cell col-status">
            <div class="status-tag" [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'verified' : 'fail']">
              <ng-container [ngSwitch]="configurationState.status">
                <span *ngSwitchCase="ConfigurationApplicationStatus.SUCCESS">{{ 'CONFIGURATIONS.VIEW_RESULTS.SUCCESS' | transloco }}</span>
                <span *ngSwitchCase="ConfigurationApplicationStatus.VERIFIED">{{ 'CONFIGURATIONS.VIEW_RESULTS.VERIFIED' | transloco }}</span>
                <span *ngSwitchDefault>{{ 'CONFIGURATIONS.VIEW_RESULTS.FAILED' | transloco }}</span>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="expandedRows[configurationState.id]" class="configuration-status-details">
          <div class="section-label">{{ 'CONFIGURATIONS.VIEW_RESULTS.CONFIGURATION_PACKAGE' | transloco }}</div>
          <div class="tbl tbl-border tbl-configuration-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
              <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
              <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
              <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
              <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
            </div>
            <div class="tbl-body">
              <ng-container *ngIf="configurationState.configResult else noDataFound">
                <div *ngFor="let configurationPackage of configurationState.configResult?.overview.packages" class="tbl-body-row">
                  <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
                  <div class="tbl-cell col-start-time">
                    {{ (configurationPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-end-time">
                    {{ (configurationPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-duration">
                    {{ configurationPackage.startDate | duration : configurationPackage.endDate : '-' }}
                  </div>
                  <div class="tbl-cell col-status" [ngClass]="{
                    'green-1-fg' : configurationPackage.status === ConfigurationPackageStatus.SUCCESS,
                    'warn-solid-fg': configurationPackage.status === ConfigurationPackageStatus.FAIL,
                    'neutral-blue-4-fg': !configurationPackage.status
                  }">{{ (configurationPackage.status | titlecase) || '-' }}
                  <mat-icon *ngIf = "configurationPackage?.errors"  class="cursor-pointer amber_color ml-20 w-5 h-5" svgIcon="warning_amber"  
                              (click)="configPackErrorDetails(configurationPackage.errors, 'configPack', configurationPackage.name)"></mat-icon>
                              </div>
                </div>
              </ng-container>
              <ng-template #noDataFound>
                <div class="ta-center">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
              </ng-template>
            </div>
          </div>
           <div class="section-label">{{ 'CONFIGURATIONS.VIEW_RESULTS.ENV_PACKAGE' | transloco }}</div>
          <div class="tbl tbl-border tbl-configuration-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
              <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
              <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
              <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
              <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
            </div>
            <div class="tbl-body">
              <ng-container *ngIf="configurationState.envPropResult else noDataFound">
                <div *ngFor="let configurationPackage of configurationState.envPropResult?.overview.packages" class="tbl-body-row">
                  <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
                  <div class="tbl-cell col-start-time">
                    {{ (configurationPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-end-time">
                    {{ (configurationPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-duration">
                    {{ configurationPackage.startDate | duration : configurationPackage.endDate : '-' }}
                  </div>
                  <div class="tbl-cell col-status" [ngClass]="{
                    'green-1-fg' : configurationPackage.status === ConfigurationPackageStatus.SUCCESS,
                    'warn-solid-fg': configurationPackage.status === ConfigurationPackageStatus.FAIL,
                    'neutral-blue-4-fg': !configurationPackage.status
                  }">{{ (configurationPackage.status | titlecase) || '-' }}
                  <mat-icon *ngIf = "configurationPackage?.errors"  class="cursor-pointer amber_color ml-20 w-5 h-5" svgIcon="warning_amber"  
                              (click)="configPackErrorDetails(configurationPackage.errors, 'envPack', configurationPackage.name)"></mat-icon>
                              </div>
                </div>
              </ng-container>
              <ng-template #noDataFound>
                <div class="ta-center">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
              </ng-template>
            </div>
          </div>
          <ng-container *ngIf="configurationState?.codeResult">
            <div class="section-label">{{ 'CONFIGURATIONS.VIEW_RESULTS.CODE_PACKAGE' | transloco }}</div>
          <div class="tbl tbl-border tbl-configuration-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
              <!-- <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
              <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
              <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
              <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div> -->
            </div>
            <div class="tbl-body">
              <ng-container *ngIf="configurationState.codeResult else noDataFound">
                <div *ngFor="let codePackage of configurationState.codeResult?.packages" class="tbl-body-row">
                  <div class="tbl-cell col-filename">{{ codePackage?.name }}</div>
                  <!-- <div class="tbl-cell col-start-time">
                    {{ (codePackage?.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-end-time">
                    {{ (codePackage?.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                  </div>
                  <div class="tbl-cell col-duration">
                    {{ codePackage?.startDate | duration : codePackage?.endDate : '-' }}
                  </div>
                  <div class="tbl-cell col-status" [ngClass]="{
                    'green-1-fg' : codePackage.status === ConfigurationPackageStatus.SUCCESS,
                    'warn-solid-fg': codePackage.status === ConfigurationPackageStatus.FAIL,
                    'neutral-blue-4-fg': !codePackage.status
                  }">{{ codePackage?.status || ('CONFIGURATIONS.VIEW_RESULTS.NOT_EXECUTED' | transloco) }}</div> -->
                </div>
              </ng-container>
              <ng-template #noDataFound>
                <div class="ta-center">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
              </ng-template>
            </div>
          </div>  
          </ng-container> 
          <ng-container *ngIf="configurationState.skipTest === 'false'">
            <div class="section-label">{{ 'CONFIGURATIONS.VIEW_RESULTS.TEST_PACKAGE' | transloco }}</div>
            <div class="tbl tbl-border tbl-test-package">
              <div class="tbl-header-row secondary">
                <div class="tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco }}</div>
                <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}</div>
                <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                <div class="tbl-cell col-success">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.SUCCESS' | transloco }}</div>
                <div class="tbl-cell col-failure">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FAILURE' | transloco }}</div>
                <div class="tbl-cell col-download-results"></div>
                <div class="tbl-cell col-view-results"></div>
              </div>
              <div class="tbl-body">
                <ng-container *ngIf="configurationState?.testResult else noDataFound">
                  <div *ngFor="let testPackage of configurationState.testResult?.overview.packages" class="tbl-body-row">
                    <div class="tbl-cell col-filename">{{ testPackage.name }}</div>
                    <div class="tbl-cell col-start-time">
                      {{ (testPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                    </div>
                    <div class="tbl-cell col-end-time">
                      {{ (testPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                    </div>
                    <div class="tbl-cell col-duration">
                      {{ testPackage.startDate | duration : testPackage.endDate : '-' }}
                    </div>
                    <div class="tbl-cell col-status" [ngClass]="{
                      'green-1-fg' : testPackage.status === ConfigurationPackageStatus.SUCCESS,
                      'warn-solid-fg': testPackage.status === ConfigurationPackageStatus.FAIL,
                      'neutral-blue-4-fg': !testPackage.status
                    }">
                      {{ testPackage.status || ('CONFIGURATIONS.VIEW_RESULTS.NOT_EXECUTED' | transloco) }}
                    </div>
                    <div class="tbl-cell col-success">{{ testPackage.success !== null ?  testPackage.success : '-' }}</div>
                    <div class="tbl-cell col-failure">{{ testPackage.failure !== null ?  testPackage.failure : '-' }}</div>
                    <div class="tbl-cell col-download-results">
                      <mat-icon class="cursor-pointer" svgIcon="file_download" (click)="downloadTestResults(configurationState, testPackage.resultsReportFile)"></mat-icon>
                    </div>
                    <div class="tbl-cell col-view-results">
                      <mat-icon class="cursor-pointer" svgIcon="visibility" (click)="viewTestResults(configurationState, testPackage.resultsReportFile)"></mat-icon>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noDataFound>
                  <div class="ta-center">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                </ng-template>
              </div>
            </div>  
          </ng-container>        
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataFound>
    <div class="flex flex-col items-center mb-20 pt-64 pb-64">
      <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
      <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RESULT_AVAILABLE' | transloco}}</div>
    </div>
  </ng-template>
  <div *ngIf="pageConfigurationStates && pageConfigurationStates.length > 0 " class="flex justify-center mt-16 mb-16 user-select-none">
    <div class="cursor-pointer" (click)="toggleViewAllResults()">
      {{ (viewAllResults ? 'CONFIGURATIONS.VIEW_RESULTS.VIEW_LATEST_RESULTS' : 'CONFIGURATIONS.VIEW_RESULTS.VIEW_ALL_RESULTS') | transloco }}
    </div>
  </div>

  <span class="flex-auto"></span>
  <app-paginator></app-paginator>

</div>

<ng-template #sortIcon let-sort="sort" let-property="property">
  <ng-container *ngIf="viewAllResults">
    <img *ngIf="!sort || sort.property !== property" class="icon-sm" src="/assets/icons/sort.svg">
    <img *ngIf="sort?.property === property" class="icon-sm" [src]="'/assets/icons/sort-' + sort.direction + '.svg'">
  </ng-container>
</ng-template>
